import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../Provider";
import { InboxMessageContext } from "../../Provider/InboxMessageContext";
import closeIcon from "../../assets/icon/close.svg";
import logo from "../../assets/img/Large PNG.png";
import { useUserMappingNotHaveRoles, useUserMappingRoles } from "../../hook/useUserMappingRoles";
import { Div } from "../../pages/commerceLandingPage/commerceLandingPage.styled";
import { httpGET } from "../../utils/ajaxHelper";
import { ADMIN_ORGANIZATION, API_CONSTANT, KEY_ITEM_LOCALSTORAGE } from "../../utils/constant";
import { RolesHandleInquiries } from "../RolesHandle";
import { IHeaderProps } from "./Header.props";
import { HeaderContainer } from "./Header.styled";

const Header: React.FC<IHeaderProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenProfileMenu, setIsOpenProfileMenu] = useState(false);
  const inboxMessageContext = useContext(InboxMessageContext);
  const user = useContext(UserContext);
  const [isFixedMenu] = useState<boolean>(true);
  const [handleMappingNoHaveRoles] = useUserMappingNotHaveRoles();
  const [handleMappingRoles] = useUserMappingRoles();

  const pageSearchActive = [
    API_CONSTANT.SEARCH_PAGE.FIRM,
    API_CONSTANT.SEARCH_PAGE.SERVICE,
    API_CONSTANT.SEARCH_PAGE.PRODUCT,
  ];

  const adminActive = [
    API_CONSTANT.ADMIN_DASHBOARD.ORGANIZATION,
    API_CONSTANT.ADMIN_DASHBOARD.OFFERING,
    API_CONSTANT.ADMIN_DASHBOARD.INQUIRY_MANAGER
  ];
  const checkShowMessage = [
    "ManagingPartner",
    "Admin",
    "FirmCommerceManagement",
    "ServiceContact",
  ].some((x: any) => user && user.roles.includes(x));
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const toggleProfileMenu = () => {
    setIsOpenProfileMenu(!isOpenProfileMenu);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const { id: firmId } = useParams();

  /// scroll to top
  const myRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (myRef.current) {
      myRef.current.scrollIntoView();
    }
  }, [location.pathname]);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: any) => {
    if (dropdownRef?.current && !dropdownRef.current.contains(event.target)) {
      setIsOpenProfileMenu(false);
    }
  };

  const { mutate: getCountUnreadInbox } = useMutation(
    () =>
      httpGET({
        url: API_CONSTANT.INBOX_MESSAGE.COUNT_UNREAD,
      }),
    {
      onSuccess: (rs) => {
        inboxMessageContext?.setUnreadInboxMessage(rs ?? 0);
      },
    },
  );

  useEffect(() => {
    if (isOpenProfileMenu) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpenProfileMenu]);

  const hasFetchedInbox = useRef(false);

  useEffect(() => {
    if (!hasFetchedInbox.current) {
      getCountUnreadInbox();
      hasFetchedInbox.current = true;
    }
  }, []);

  return (
    <>
      <div
        ref={myRef}
        style={{ height: "0", width: "0" }}
      ></div>
      <HeaderContainer className="sticky top-0 z-[99999]">
        <div>
          <Div className="top-header">
            <Div className="logo w-1/3">
              <img
                src={logo}
                alt=""
              />
            </Div>
            <Div className="right-menu w-2/3 flex justify-end h-[43px]">
              <ul>
                {user &&
                  (user.roles.includes("Admin") ||
                    user.roles.includes("FirmCommerceManagement") ||
                    user.roles.includes("ManagingPartner") ||
                    user.roles.includes("VendorUser") ||
                    user.myServices.length > 0) && (
                    <li className="li-item ">
                      <NavLink
                        className={({ isActive }) =>
                          `right-menu-item no-underline !inline ${isActive ? "NavActive" : ""}`
                        }
                        to={`/dashboard`}
                      >
                        Dashboard
                      </NavLink>
                    </li>
                  )}

                <li>
                  <NavLink
                    className={({ isActive }) =>
                      `right-menu-item no-underline !inline ${isActive ? "NavActive" : ""}`
                    }
                    to={`/commerceProfile/${user?.individual.fkOrgId}?tab=home`}
                    onClick={() => {
                      const urlObj = window.location.origin + "/search-services";
                      localStorage.setItem(
                        KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE,
                        urlObj.toString(),
                      );
                    }}
                  >
                    My Organization
                  </NavLink>
                </li>
                {
                  handleMappingNoHaveRoles(
                    ["VendorUser"],
                    true,
                  ) ?
                    <li className="relative">
                      <NavLink
                        className={({ isActive }) =>
                          `right-menu-item no-underline !inline ${isActive || pageSearchActive.includes(location.pathname) ? "NavActive" : ""
                          }`
                        }
                        to={`/search-services`}
                      >
                        Search
                      </NavLink>
                    </li>
                    : null
                }
                {
                  handleMappingRoles(["Admin"]) && (
                    <li className="li-item ">
                      <NavLink
                        className={({ isActive }) =>
                          `right-menu-item no-underline !inline ${isActive || adminActive.includes(location.pathname) ? "NavActive" : ""}`
                        }
                        to={`/dashboard-admin`}
                      >
                        Admin
                      </NavLink>
                    </li>
                  )
                }
              </ul>
            </Div>
            <div
              className="relative relative-avatar"
              ref={dropdownRef}
            >
              {/* Avatar */}
              <div
                className="profile-avatar rounded-full border-transparent flex items-center justify-center w-[42px] h-[42px] cursor-pointer"
                onClick={toggleProfileMenu}
              >
                <img
                  src={
                    user?.individual.avatar
                      ? user.individual.avatar
                      : "https://cdn-icons-png.flaticon.com/512/9203/9203764.png"
                  }
                  alt="Avatar"
                  className="w-full h-full circular-image"
                />
                {inboxMessageContext && (inboxMessageContext!.unreadInboxMessage! >= 1) && (
                  <div className={`${inboxMessageContext!.unreadInboxMessage! > 99 ? 'inquiries-count-plus' : 'inquiries-count'} rounded-full border-transparent`}>
                    <p className="text-[10px] font-[700] text-[#ffffff] flex items-center justify-center ">
                      {inboxMessageContext!.unreadInboxMessage! > 99 ? '99+' : inboxMessageContext!.unreadInboxMessage!}
                    </p>
                  </div>
                )}
              </div>

              {/* Dropdown Menu */}
              {isOpenProfileMenu && (
                <div
                  className={`absolute transform bg-white border rounded-lg shadow-lg w-[300px] profile-menu ${window.innerWidth > 1597
                    ? "top-[120%] left-[-120px] translate-x-0"
                    : window.innerWidth > 1024
                      ? "top-[100%] left-[-120px] -translate-x-1/3"
                      : "top-[100%] left-[-120px] -translate-x-1/2"
                    }`}
                >
                  {" "}
                  <ul className="text-gray-700">
                    <li className="px-4 flex">
                      <p id="user-name">
                        {user?.individual.firstName + " " + user?.individual.lastName}
                      </p>
                      <div className="flex items-center justify-center pl-[20px]">
                        {user?.individual.fkOrg?.orgId === ADMIN_ORGANIZATION!.ID ? (
                          <p className="rounded-[5px] border py-[5px] px-[10px] bg-[#EAEAEA] text-[11px] font-[500] leading-[12.89px]">
                            Admin
                          </p>
                        ) : null}
                      </div>
                    </li>
                    <li
                      className="border-t-[2px] menu-item-option flex cursor-pointer menu-item text-black hover:text-white hover:bg-blue-500 group"
                      onClick={() => {
                        navigate("/inquiry");
                        setIsOpenProfileMenu(false);
                      }}
                    >
                      <InquiriesIcon className="fill-[#0971A2] group-hover:fill-white mt-[4px]" />
                      <span className="pl-[20px]">Inquiries</span>
                      {inboxMessageContext && (inboxMessageContext!.unreadInboxMessage! >= 1) && (
                        <div className={`${inboxMessageContext!.unreadInboxMessage! > 99 ? 'inquiries-count-dropdown-plus' : 'inquiries-count-dropdown'} rounded-full border-transparent`}>
                          <p className="text-[10px] font-[700] text-[#ffffff] flex items-center justify-center ">
                            {inboxMessageContext!.unreadInboxMessage! > 99 ? '99+' : inboxMessageContext!.unreadInboxMessage!}
                          </p>
                        </div>
                      )}
                    </li>

                    {/* <li
                      className="menu-item-option flex cursor-pointer menu-item text-black hover:text-white hover:bg-blue-500 group"
                      onClick={() => {
                        // navigate("");
                        setIsOpenProfileMenu(false)
                      }}
                    >
                      <SettingIcon className="fill-[#0971A2] group-hover:fill-white mt-[4px]" />
                      <NavLink
                        className="color-[#000000] pl-[20px] font-[400] leading-[18.75px] cursor-pointer"
                        to="/#"
                      >
                        Settings
                      </NavLink>
                    </li> */}

                    <li
                      className="menu-item-option flex cursor-pointer menu-item text-black hover:text-white hover:bg-blue-500 group"
                      onClick={() => {
                        navigate("/");
                        setIsOpenProfileMenu(false);
                      }}
                    >
                      <span className="pl-[20px] ml-[15px]">About Commerce Marketplace</span>
                    </li>

                    <li
                      className="border-t-[2px] menu-item-option flex cursor-pointer menu-item text-black hover:text-white hover:bg-blue-500 group rounded-b-[5px]"
                      onClick={() => {
                        navigate(
                          process.env.REACT_APP_AG_CONNECT_URL
                            ? process.env.REACT_APP_AG_CONNECT_URL
                            : "#",
                        );
                      }}
                    >
                      {" "}
                      <GoBackIcon className="fill-[#0971A2] group-hover:fill-white mt-[4px]" />
                      <a
                        className="color-[#000000] pl-[20px] font-[400] leading-[18.75px] cursor-pointer"
                        href={`${process.env.REACT_APP_AG_CONNECT_URL
                          ? process.env.REACT_APP_AG_CONNECT_URL
                          : "#"
                          }`}
                      >
                        Back to AG Connect
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </Div>
          <Div className="navbar w-full">
            <Div className="navbar-desktop"></Div>
          </Div>
        </div>
        <div className={isFixedMenu ? "fixed inset-x-0 top-0 z-[99999] bg-white shadow-lg" : ""}>
          <Div
            className={`mobile-menu w-full ${isOpen ? "mobile:!fixed mobile:bg-white tablet:!fixed tablet:bg-white" : ""
              } z-[99999]`}
          >
            <Div className="mobile-menu-header">
              <Div className="mobile-menu-header-item w-1/5 py-2.5">
                <button
                  className="menu-toggle"
                  onClick={toggleMenu}
                >
                  <img
                    src="/AG_LandingPage/menu-mobile.svg"
                    alt=""
                  />
                </button>
              </Div>
              <Div className="mobile-logo">
                <img
                  src="/AG_LandingPage/logo.png"
                  alt=""
                />
              </Div>
              <Div className="mobile-logo-space w-1/5"></Div>
            </Div>
          </Div>
        </div>
      </HeaderContainer>
      <HeaderContainer>
        {isOpen && (
          <div
            className={`menu-container ${isOpen ? "w-[100%] mobile:!fixed tablet:!fixed" : ""
              } z-[999990000]`}
          >
            <button
              className="close-button"
              onClick={toggleMenu}
            >
              <img
                src={closeIcon}
                alt=""
              />
            </button>

            <ul className="menu-list !h-full">
              <li onClick={toggleMenu}>
                <Link to={`/commerceProfile/${user?.individual.fkOrgId}?tab=home`}
                  onClick={() => {
                    const urlObj = window.location.origin + "/search-services";
                    localStorage.setItem(
                      KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE,
                      urlObj.toString(),
                    );
                  }}>My Organization</Link>
              </li>
              {
                handleMappingNoHaveRoles(
                  ["VendorUser"],
                  true,
                ) ?
                  <li onClick={toggleMenu}>
                    <Link to={`/search-services`}>Search</Link>
                  </li>
                  : null
              }

              {user &&
                (user.roles.includes("Admin") ||
                  user.roles.includes("FirmCommerceManagement") ||
                  user.roles.includes("ManagingPartner") ||
                  user.roles.includes("VendorUser") ||
                  user.myServices.length > 0) && (
                  <li onClick={toggleMenu}>
                    <Link to={`/dashboard`}>Dashboard</Link>
                  </li>
                )}
              <li
                onClick={toggleMenu}
                className="flex justify-between items-center"
              >
                <Link to="/inquiry">Inquiries</Link>
                <RolesHandleInquiries
                  firmId={Number(firmId) ?? 0}
                  fkOrgId={user!.individual!.fkOrgId}
                  roles={["Admin", "FirmCommerceManagement", "ManagingPartner", "ServiceContact"]}
                >
                  {checkShowMessage && inboxMessageContext?.unreadInboxMessage ? (
                    <div className={` ${inboxMessageContext?.unreadInboxMessage! > 99 ? 'w-[30px]' : 'w-[22px]'} rounded-full h-[22px] bg-white text-[0.8125rem] font-bold text-[#4697D1] flex justify-center items-center`}>
                      {inboxMessageContext?.unreadInboxMessage! > 99 ? '99+' : inboxMessageContext?.unreadInboxMessage!}
                    </div>
                  ) : null}
                </RolesHandleInquiries>
              </li>
              {/* <li onClick={toggleMenu}>Settings</li> */}
              <li onClick={toggleMenu}>
                <Link to="/">About Commerce Marketplace</Link>
              </li>
              <li onClick={toggleMenu}>
                <Link
                  to={`${process.env.REACT_APP_AG_CONNECT_URL
                    ? process.env.REACT_APP_AG_CONNECT_URL
                    : "#"
                    }`}
                >
                  AG Connect
                </Link>
              </li>
            </ul>
          </div>
        )}
      </HeaderContainer>
    </>
  );
};

export default Header;

export const InquiriesIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4997 9.28242V0.697816L9.00286 4.9908L13.4997 9.28242Z"
        className="icon-path"
      />
      <path
        d="M7.88229 6.05662C7.37986 6.53616 6.62121 6.53616 6.11885 6.05662L5.3027 5.27705L0.828254 9.5486H13.1741L8.69841 5.27842L7.88226 6.05799L7.88229 6.05662Z"
        className="icon-path"
      />
      <path
        d="M0.5 0.697816V9.28242L4.99684 4.9908L0.5 0.697816Z"
        className="icon-path"
      />
      <path
        d="M6.36647 5.7595C6.72642 6.10374 7.27009 6.10374 7.63129 5.7595L13.1931 0.451172H0.804678L6.3665 5.76087L6.36647 5.7595Z"
        className="icon-path"
      />
    </svg>
  );
};

export const SettingIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.4106 3.48647C11.3375 3.22562 11.3169 3.21371 11.0507 3.19658C10.6486 3.17087 10.2469 3.14421 9.8509 3.11137C9.62874 3.09328 9.6339 3.08804 9.65874 2.86765C9.71779 2.36306 9.7684 1.85609 9.82558 1.3334C9.81949 1.24724 9.76278 1.17346 9.6817 1.14681C9.0265 0.821682 8.37223 0.494653 7.71893 0.165724C7.62051 0.107173 7.49537 0.127165 7.41898 0.213325C7.03982 0.588428 6.65597 0.957828 6.27682 1.33341C6.25245 1.37054 6.21168 1.39291 6.16762 1.39291C6.12357 1.39291 6.08279 1.37054 6.05842 1.33341C5.64786 0.921172 5.23308 0.515604 4.82022 0.106257C4.70024 -0.0156045 4.64399 -0.0279856 4.49496 0.0453265C3.83881 0.364739 3.18825 0.687478 2.53447 1.00309C2.43137 1.04498 2.37419 1.15637 2.39903 1.26633C2.45668 1.80377 2.50682 2.34357 2.56587 2.881C2.57993 2.92337 2.57197 2.97002 2.54431 3.00477C2.51713 3.03952 2.47401 3.0576 2.43043 3.05284C1.84739 3.12853 1.2653 3.21136 0.682305 3.29657C0.575916 3.30085 0.488272 3.38225 0.474679 3.48888C0.322363 4.20053 0.168631 4.916 0.0163158 5.63389C-0.0211783 5.81192 -0.000555951 5.85429 0.147071 5.95093L1.46686 6.79444C1.58684 6.8687 1.58684 6.89203 1.51841 7.01484L0.650893 8.53056C0.564657 8.68051 0.569343 8.73049 0.678545 8.8633L2.05832 10.5461C2.08504 10.5989 2.13284 10.638 2.18908 10.6537C2.24579 10.6694 2.30625 10.6608 2.35593 10.6289L3.81117 10.0929C3.98037 10.0306 3.98974 10.0344 4.05113 10.2C4.2597 10.7313 4.47107 11.2625 4.674 11.7967C4.70634 11.9247 4.82491 12.0104 4.95473 11.999H7.08811C7.27418 11.999 7.31027 11.9671 7.3665 11.7857C7.52961 11.2592 7.69411 10.7328 7.85346 10.2015C7.85487 10.1587 7.8783 10.1201 7.91532 10.0992C7.95188 10.0787 7.99687 10.0787 8.03343 10.1001C8.57334 10.2648 9.11326 10.4219 9.65557 10.5876C9.87631 10.6533 9.911 10.6423 10.0441 10.4571L11.2945 8.72585C11.3892 8.59447 11.3892 8.54068 11.2945 8.40168C11.0016 7.95945 10.7115 7.5158 10.4153 7.07448H10.4148C10.3839 7.04211 10.3703 6.99593 10.3797 6.95119C10.3886 6.90692 10.4191 6.86979 10.4608 6.85265C10.9313 6.51516 11.3977 6.17147 11.8659 5.82921C11.998 5.73305 12.0196 5.67688 11.9859 5.5355C11.7928 4.85145 11.6011 4.16833 11.4108 3.48676L11.4106 3.48647ZM5.96844 8.26236C5.16137 8.26236 4.41528 7.8249 4.01167 7.11514C3.60814 6.40492 3.60814 5.53045 4.01167 4.82024C4.4152 4.11049 5.16133 3.67302 5.96844 3.67302C6.77555 3.67302 7.52159 4.11048 7.9252 4.82024C8.32874 5.53046 8.32874 6.40493 7.9252 7.11514C7.52167 7.82489 6.77555 8.26236 5.96844 8.26236Z" />
    </svg>
  );
};

export const GoBackIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.79289 3.0103C3.12482 2.69711 3.64786 2.71264 3.96103 3.04456C4.27422 3.37702 4.25923 3.90006 3.92677 4.21324L2.90799 5.1742H7.73903C8.18819 5.18437 8.54688 5.55162 8.54688 6.00078C8.54688 6.44993 8.18819 6.81719 7.73903 6.82736H2.90799L3.92677 7.78992C4.25869 8.10311 4.27367 8.62668 3.9605 8.95859C3.64677 9.29052 3.12373 9.3055 2.79183 8.99232L0.258579 6.60037C0.0936937 6.44405 0.000540733 6.22722 0.000540733 5.99971C0.000540733 5.77272 0.0936918 5.55536 0.258579 5.39904L2.79289 3.0103Z" />
      <path d="M6.61484 10.3502H10.3467V1.65067H6.61484C6.15872 1.65067 5.78879 1.28075 5.78879 0.824627C5.78879 0.367974 6.15872 -0.00195312 6.61484 -0.00195312H11.1734C11.6295 -0.0014178 11.9995 0.368509 12 0.824627V11.1762C11.9989 11.6323 11.6295 12.0023 11.1734 12.0028H6.61484C6.15872 12.0028 5.78879 11.6329 5.78879 11.1762C5.78879 10.7201 6.15872 10.3502 6.61484 10.3502Z" />
    </svg>
  );
};
